import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navbar } from "react-bootstrap";
import Breadcrumb from "../src/Breadcrumb.jsx";  // Import Breadcrumb
import ScrollToTop from "./components/ScrollToTop";
import WhatsappRedirect from "./pages/whatsapprevert.jsx";
// Import Pages
import Homepage from './pages/Homepage';
import NewHomePage from './pages/NewHomePage';
import About from './pages/About';
import Products from './pages/Products';
import Trampoline from "./pages/Product/Trampoline Park/Trampoline";
import Performance from "./pages/Product/Trampoline Park/Performance";
import Service from "./pages/Services";
import Form from "./pages/Form";
import Individualproductscreen from './pages/Individualproductscreen';
import Projects from './pages/Projects';
import GetQuotations from "./pages/Getquotations";
import Playground from "./pages/Product/Indoor Playground/Playground";
import Interactivegames from "./pages/Product/Interactive Games/Interactivegames";
import InteractivegamesProduct from "./pages/Product/Interactive Games/InteractivegamesProduct";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails.jsx";
import ProductsPlayground from "./pages/Product/Indoor Playground/ProductsPlayground";
import ClimbingWall from "./pages/Product/ClimbingWall/ClimbingWall";
import ProductsClimbing from "./pages/Product/ClimbingWall/ProductsClimbing";
import NinjaPark from "./pages/Product/NinjaPark/NinjaPark.jsx"
import ProductsNinja from "./pages/Product/NinjaPark/ProductsNinja.jsx"
import ProductsSoftware from "./pages/Product/ManagementSoftware/ProductsSoftware.jsx"
import ManagementSoftware from "./pages/Product/ManagementSoftware/ManagementSoftware.jsx";
import { HelmetProvider } from "react-helmet-async";

import MetaPixel from "./MetaPixel";
import MetaPixelTracker from "./MetaPixelTracker";


function App() {
  return (
    <div>
      <HelmetProvider>
      <Router>
      <ScrollToTop />
      <Navbar />

      <MetaPixel />
      <MetaPixelTracker />
      
      <Routes>
        
        <Route path="/" element={<Homepage />} />
        <Route path="/Landingpage" element={<NewHomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/Products" element={<Products />} />
        <Route path="TrampolinePark" element={<Trampoline />} />
        <Route path="/Roadmap" element={<Service />} />
        <Route path="/iproducts" element={<Individualproductscreen />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/ContactUs" element={<Form />} />
        <Route path="/getquotations" element={<GetQuotations />} />
        <Route path="IndoorPlayground" element={<Playground />} />
        <Route path="Interactivegames" element={<Interactivegames />} />
        <Route path="Climbingwall" element={<ClimbingWall />} />
        <Route path="Climbingwall/:type" element={<ProductsClimbing />} />
        <Route path="NinjaPark" element={<NinjaPark />} />
        <Route path="NinjaPark/:type" element={<ProductsNinja />} />
        <Route path="EntranceSoftware" element={<ManagementSoftware />} /> 
        {/* <Route path="Products/ManagementSoftware/:type" element={<ProductsSoftware/>}/> */}
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Blog/:id" element={<BlogDetails />} />
        <Route path="Products/Performance" element={<Performance />} />
        <Route path="TrampolinePark/:type" element={<Performance />} />
        <Route path="Interactivegames/:type" element={<InteractivegamesProduct />} />
        <Route path="/whatsapp" element={<WhatsappRedirect />} />
        <Route path="IndoorPlayground/:type" element={<ProductsPlayground />} />
      </Routes>
    </Router>
    </HelmetProvider>
      
     




    </div>
  );
}

export default App;
 